export default function getUrlParamPrefix(url) {
  let prefix = "?"
  if (url.includes("?")) {
    prefix = "&"
  }
  return prefix
}
